import { getObjectName } from 'utils/utils'

export const INITIAL_STATE = {
    title: null,
    code: null,
    description: null,
    terms_and_conditions: null,
    thumbnail: null,
    is_shown_in_checkout: false,
    type: null,
    date_start: null,
    date_expires: null,
    discount_type: 'nominal',
    amount_percentage: null,
    amount_nominal: null,
    max_amount: null,
    gifts: [],
    is_free_shipping: false,
    combine_validation: false,
    restriction: {
        minimum_amount: null,
        maximum_amount: null,
        individual_use: false,
        individual_type: false,
        exclude_sale_items: false,
        include_product_ids: [],
        exclude_product_ids: [],
        include_category_ids: [],
        exclude_category_ids: [],
        include_brand_ids: [],
        exclude_brand_ids: [],
        shipping_courier: [],
        payment_method: [],
        new_user_only: false,
        allowed_email: [],
    },
    limit: {
        usage_limit: null,
        usage_limit_per_user: null,
        usage_limit_to_x_item: null,
    },
}

export const GET_FIELD_NAME = {
    title: 'Nama voucher',
    code: 'Kode voucher',
    description: 'Deskripsi voucher',
    terms_and_conditions: 'Term & Condition',
    type: 'Tipe voucher',
    date_start: 'Tanggal mulai',
}

export const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    thumbnail: 'Voucher thumbnail',
    is_shown_in_checkout: 'Show on checkout page',
    date_expires: 'Expired date voucher',
    discount_type: 'Discount type',
    amount: 'Nilai voucher',
    max_amount: 'Voucher max amount',
    gifts: 'Gifts',
    is_free_shipping: 'Free shipping',
    restriction: {
        minimum_amount: 'Minimum spend',
        maximum_amount: 'Maksimum spend',
        individual_use: 'Individual use only',
        individual_type: 'Individual Use Only in This Voucher Type',
        exclude_sale_items: 'Exclude sale item',
        include_product_ids: 'Includes product',
        exclude_product_ids: 'Excludes product',
        include_category_ids: 'Includes category',
        exclude_category_ids: 'Excludes category',
        include_brand_ids: 'Includes brand',
        exclude_brand_ids: 'Excludes brand',
        shipping_courier: 'Shipping courier',
        payment_method: 'Payment method',
        new_user_only: 'Valid for new customer',
        allowed_email: 'Allowed email',
    },
    limit: {
        usage_limit: 'Usage limit per voucher',
        usage_limit_per_user: 'Usage limit per user',
        usage_limit_to_x_item: 'Usage limit to X item',
    },
}

export const SECTION_FIELDS = {
    general_settings: getObjectName(INITIAL_STATE, 0, 15),
    restriction: getObjectName(INITIAL_STATE, 16, 17),
    usage_limit: getObjectName(INITIAL_STATE, 17, 18),
}
